<template>
    <div class="event-info">
        <!-- <h2 class="info-title">
          {{ $t("profiles.labels.concertInformationOf") }}
          <span class="event-name">{{ nameFormatted }}</span>
          {{ $t("profiles.in") }} {{ event.city.name }}
        </h2>
        <div class="info flex flex-col text-color-gray gap-2 text-s mb-10">
          <div>
            {{ $t("wegow.filters.date") }}:
            <span>{{ longDateFormated }}</span>
            <span v-if="isFestival"> - {{ longEndDateFormated }}</span>
          </div>

          <div>
            {{ $t("profiles.labels.doorOpening") }}:
            <span>{{ hourFormatted }}h</span>
          </div>

          <div>
            {{ $t("profiles.labels.place") }}:
            <span>{{ event.venue.name }}, </span>
            <span>{{
              event.city.name || event.city?.administrative_division
            }}</span>
          </div>
          <div v-if="event?.artists?.length > 0 && event?.artists?.length < 5">
            {{ $t("profiles.titles.artists") }}:
            <span
              v-for="(artist, index) in event.artists"
              :key="artist.id"
              :href="artist.permalink"
            >
                {{ artist.name }}
              <span v-if="index !== event.artists.length - 1">, </span>
            </span>
          </div>
          <div v-if="event.price || event.price === 0">
            {{ $t("profiles.labels.anticipatedPrice") }}:
            <span>{{ priceFormatted }}</span>
          </div>
          <div>
            {{ $t("profiles.labels.boxOffice") }}
            <span>{{}}</span>
          </div> 
        </div> -->
        <div class="description-title">
          <p>{{ $t("profiles.labels.descriptionInformationOf") }}</p>
        </div>
        <show-more
          v-if="event?.html_personalization?.html_description"
          :html-personalization="true"
          :text="event?.html_personalization?.html_description"
          class="mt-4 mb-4 description__html"
        />
        <show-more v-else :text="event.description" class="mt-4 mb-4" />
        <social-media
          v-if="event.links.length > 0"
          :medias-to-show="formatSocialMedia(event.links)"
          :web="
            formatSocialMediaUrl(event.links).web
              ? formatSocialMediaUrl(event.links).web
              : ''
          "
          :facebook="
            formatSocialMediaUrl(event.links).facebook
              ? formatSocialMediaUrl(event.links).facebook
              : ''
          "
          :spotify="
            formatSocialMediaUrl(event.links).spotify
              ? formatSocialMediaUrl(event.links).spotify
              : ''
          "
          :twitter="
            formatSocialMediaUrl(event.links).twitter
              ? formatSocialMediaUrl(event.links).twitter
              : ''
          "
          :instagram="
            formatSocialMediaUrl(event.links)?.instagram
              ? formatSocialMediaUrl(event.links).instagram
              : ''
          "
          :youtube="
            formatSocialMediaUrl(event.links).youtube
              ? formatSocialMediaUrl(event.links).youtube
              : ''
          "
        />
    </div>
</template>

<script setup>
import { useEvent } from "@/composables/useEvent";

import ShowMore from "@/components/events/ShowMore";
import SocialMedia from "@/components/events/SocialMedia";

// import { formatCurrency } from "@/plugins/currency";
// import { formatHour, formatLongDate } from "@/plugins/date-formater";
import {
  formatSocialMediaUrl,
  formatSocialMedia
} from "@/plugins/social-media-formater";
// import { computed } from "vue";
// import { useI18n } from "vue-i18n";

const { details:event } = useEvent();
// const { t } = useI18n();

// const isFestival = computed(() => event.value.type === 1);

// const nameFormatted = computed(() => {
//   let title = event.value.title || "";
//   title = title.replace(t("wegow.headerDetails.start"), "");
//   title = title.replace(t("wegow.headerDetails.startStreaming"), "");
//   return title.replace(
//     t("wegow.headerDetails.in", {
//       city: event.value.city?.name || event.value.city?.administrative_division
//     }),
//     ""
//   );
// });

// const priceFormatted = computed(
//   () =>
//     formatCurrency(Number(event.value.price).toFixed(2), event.value.currency)
// );

// const longDateFormated = computed(() => {
//   let infoDate = formatLongDate(
//     event.value.start_date,
//     'es',
//     false
//   );
//   return t("wegow.date.dateFormat", infoDate);
// });

// const longEndDateFormated = computed(() => {
//   let infoDate = formatLongDate(
//     event.value.end_date,
//     'es',
//     false
//   );
//   return t("wegow.date.dateFormat", infoDate);
// });

// const hourFormatted = computed(() =>
//   formatHour(event.value.start_date, 'es', false)
// );

</script>

<style lang="scss" scoped>
.event-info{
    margin-left: auto;
    margin-right: auto;
    max-width: $maxWidthEventInfo;
    width: 100%;
    background-color: $infoCardColor;
    border-radius: 24px;
    padding: 12px;
    margin-top: 8px;
    color: $descriptionTitleColor;
    h2,
    .description-title {
        font-size: $descriptionTitleSize;
        color: $descriptionTitleColor;
        margin-top: $descriptionMarginTop;
        margin-bottom: $descriptionMarginbBottom;
      font-weight: 700;
    }
    .info-title {
        font-size: $infoTitleSize;
        color: $infoTitleColor;
        margin-top: $infoMarginTop;
        margin-bottom: $infoMarginbBottom;
        .event-name {
            color: $infoTitleEventColor;
        }
    }
    .info {
      color: $descriptionColor;
    }
    .description-title {
        font-size: $descriptionTitleSize;
        color: $descriptionTitleColor;
        margin-top: $descriptionMarginTop;
        margin-bottom: $descriptionMarginbBottom;

    }

}
</style>
